import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmAuthVerificationInvalidCodeError } from '@/core/error/transport/auth/TmAuthVerificationInvalidCodeError'

export const authTFAVerificationInvalidCodeRule: CustomErrorRule = {
  endpoint: EndpointsEnum.login,
  subCodes: ['auth.incorrect_login_code', 'auth.two_factor_request_failed', 'user.verification.totp_tfa_code_is_wrong'],
  klass: TmAuthVerificationInvalidCodeError,
}
